<template>
  <el-drawer
    class="edit-table"
    title="网站专题"
    :visible.sync="showDrawer"
    :direction="direction"
    :size="'calc(100vw - 256px)'"
    :before-close="handleClose"
  >
    <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="150px" style="margin:10px 30px;">
      <el-form-item label="专题封面：">
        <uploadImage :limit="1" v-model="editForm.cover"></uploadImage>
      </el-form-item>
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="专题标题：" prop="title">
            <el-input v-model="editForm.title" placeholder="请输入专题标题" clearable/>
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="专题类型:" prop="type">
            <el-select v-model="editForm.type" placeholder="请选择专题类型" class="ele-block" clearable>
              <el-option label="类型1" :value="1"/>
              <el-option label="类型2" :value="2"/>
              <el-option label="类型3" :value="3"/>
              <el-option label="类型4" :value="4"/>
              <el-option label="类型5" :value="5"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="专题简介:">
        <el-input v-model="editForm.intro" placeholder="请输入专题简介" :rows="4" type="textarea"/>
      </el-form-item>
      <el-form-item label="专题图集">
        <uploadImage :limit="10" v-model="editForm.imgs"></uploadImage>
      </el-form-item>
      <!-- 富文本编辑器 -->
      <el-form-item label="专题内容：" prop="content">
        <tinymce-editor v-model="editForm.content" :init="initEditor"/>
      </el-form-item>
      <el-form-item style="text-align: center;margin-left:-100px;margin-top:10px;">
        <el-button @click="save" type="primary" size="medium">保存 </el-button>
        <el-button @click="$emit('returnBack')" size="medium">返回</el-button>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>

<script>
  import uploadImage from '@/components/uploadImage'
  import TinymceEditor from '@/components/TinymceEditor'
  export default {
    name: "ArticleEdit",
    components: {uploadImage,TinymceEditor},
    data() {
      return {
        showDrawer: this.visible,
        direction: 'rtl',
        editForm: {type:1},  // 表单数据
        editRules: {  // 表单验证规则
          title: [
            {required: true, message: '请输入专题标题', trigger: 'blur'}
          ],
          type: [
            {required: true, message: '请选择专题类型', trigger: 'blur'}
          ],
        },
      };
    },
    props: {
      visible: {
        type: Boolean,
        default() {
          return false;
        }
      },
      projectId: {
        type: String,
        default() {
          return 0;
        }
      },
    },
    computed: {
      /**
       * 初始化编辑器
       */
      initEditor() {
        return {
          height: 525,
          file_picker_callback: this.file_picker_callback,
          skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' : '/tinymce/skins/ui/oxide',
          content_css: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/content/dark/content.css' : '/tinymce/skins/content/default/content.css',
          images_upload_handler: (blobInfo, success, error) => {
            let file = blobInfo.blob();
            // 使用axios上传
            const formData = new FormData();
            formData.append('file', file, file.name);
            this.$http.post('/upload/uploadImage', formData).then(res => {
              if (res.data.code == 0) { 
                  success(res.data.data); 
              } else { 
                  error(res.data.msg); 
              }
            }).catch(e => {
                console.error(e);
                error(e.message);
            });
        }
        };
      }
    },
    mounted() {
      this.getProjectInfo();
    },
    methods: {
      /**
       * 获取专题详情
       */
      getProjectInfo(){
        if (this.projectId > 0) {
          this.$http.get('/webproject/info?id=' + this.projectId).then(res => {
            if (res.data.code === 0) {
              this.editForm = res.data.data;
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            this.$message.error(e.message);
          });
        }
      },
      /* 保存编辑 */
      save() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({lock: true});
            this.$http.post('/webproject/edit', this.editForm).then(res => {
              loading.close();
              if (res.data.code === 0) {
                this.$message({type: 'success', message: res.data.msg});
                this.$emit('reload')
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(e => {
              loading.close();
              this.$message.error(e.message);
            });
          } else {
            return false;
          }
        });
      },
      /**
       * 关闭页面
       */
      handleClose(hide) {
        if (hide) {
          hide();
        }
        this.$emit("reload");
      }
    }
  };
</script>

<style scoped>
/* 选项卡 */
.demo-icon-tabs >>> .el-tabs__nav-scroll {
  padding: 0 20px;
}

.demo-icon-tabs >>> .el-tabs__item {
  height: 45px;
  line-height: 45px;
}
</style>
